import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridFillIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M4 4h16v16H4z" }), /* @__PURE__ */ _jsx("path", {
		d: "M4 9.33h16M4 14.66h16M9.33 4v16m5.33-16v16",
		opacity: .5
	})]
});
export default SvgGridFillIcon;
